(function () {
  "use strict";

  function arproUi(key, fallback, values) {
    var translations = window.arproI18n;
    var template = translations && Object.prototype.hasOwnProperty.call(translations, key) && typeof translations[key] === "string" && translations[key]
      ? translations[key] : fallback;
    return String(template).replace(/\{([A-Za-z][A-Za-z0-9_]*)\}/g, function (match, name) {
      return values && Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match;
    });
  }

  var root = document.querySelector("[data-arpro-tariff-root]");
  if (!root) return;

  var allowedModes = ["trad", "grossistes"];
  var serverMode = root.dataset.arproCurrentMode;
  var hasAuthorizedMode = allowedModes.indexOf(serverMode) !== -1;
  var requestedStatus = root.querySelector("[data-arpro-tariff-requested-status]");

  function requestedModeCopy(mode, submitted) {
    if (mode === "trad") {
      return submitted
        ? arproUi("js_residual_094", "Demande transmise : TARIFS TRAD HT — en attente de validation par l’ADV.")
        : arproUi("js_residual_095", "Préférence sélectionnée : TARIFS TRAD HT — demande non envoyée.");
    }

    if (mode === "grossistes") {
      return submitted
        ? arproUi("js_residual_096", "Demande transmise : TARIFS GROSSISTE FR HT — en attente de validation par l’ADV.")
        : arproUi("js_residual_097", "Préférence sélectionnée : TARIFS GROSSISTE FR HT — demande non envoyée.");
    }

    if (mode === "review") {
      return submitted
        ? arproUi("js_residual_098", "Demande de conseil transmise à l’ADV.")
        : arproUi("js_residual_099", "Conseil sélectionné — demande non envoyée.");
    }

    return "";
  }

  function applyRequestedMode(mode, submitted) {
    root.querySelectorAll("[data-arpro-tariff-choice]").forEach(function (choice) {
      choice.classList.remove("is-requested");
      choice.removeAttribute("data-arpro-tariff-requested");
    });

    if (hasAuthorizedMode) {
      if (requestedStatus) {
        requestedStatus.hidden = true;
        requestedStatus.textContent = "";
      }
      return;
    }

    var copy = requestedModeCopy(mode, submitted);
    var requestedChoice = allowedModes.indexOf(mode) !== -1
      ? root.querySelector('[data-arpro-tariff-choice="' + mode + '"]')
      : null;

    if (requestedChoice) {
      requestedChoice.classList.add("is-requested");
      requestedChoice.setAttribute("data-arpro-tariff-requested", "true");
    }

    if (requestedStatus) {
      requestedStatus.textContent = copy;
      requestedStatus.hidden = !copy;
    }
  }

  function applyServerContext() {
    if (hasAuthorizedMode) {
      document.documentElement.dataset.arproTariffMode = serverMode;
    } else {
      delete document.documentElement.dataset.arproTariffMode;
    }

    document.querySelectorAll("[data-arpro-mode-copy]").forEach(function (copy) {
      copy.hidden = !hasAuthorizedMode || copy.dataset.arproModeCopy !== serverMode;
    });

    document.querySelectorAll("[data-arpro-tariff-short]").forEach(function (label) {
      label.textContent = hasAuthorizedMode
        ? (serverMode === "grossistes" ? "GROSSISTES" : "TRAD")
        : arproUi("js_residual_100", "ACCÈS PRO");
    });

    root.dataset.arproEnhanced = "true";
  }

  applyServerContext();
  applyRequestedMode(
    document.documentElement.dataset.arproRequestedTariffMode || "",
    document.documentElement.dataset.arproTariffRequestState === "submitted"
  );

  document.addEventListener("arpro:tariff-requested", function (event) {
    var mode = event.detail && event.detail.mode ? event.detail.mode : "";
    applyRequestedMode(mode, Boolean(event.detail && event.detail.submitted));
  });
})();
